import { useState } from "react";
import Sidebar from "./Sidebar";
import MobileBottomNav from "./MobileBottomNav";
import PWAInstallBanner from "./PWAInstallBanner";
import { ListIcon, ShippingContainerIcon } from "@phosphor-icons/react";

export default function Shell({ title, subtitle, actions, children }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <Sidebar open={open} onClose={() => setOpen(false)} />

      <main className="lg:ml-64 min-h-screen bg-zinc-50/60 pb-[72px] lg:pb-0">
        {/* Mobile top bar (visible < lg) */}
        <div className="lg:hidden flex items-center justify-between px-4 py-3 border-b border-zinc-200 bg-white sticky top-0 z-20">
          <button
            data-testid="mobile-menu-btn"
            onClick={() => setOpen(true)}
            className="p-2 -ml-2 text-zinc-950"
            aria-label="Open menu"
          >
            <ListIcon size={22} weight="bold" />
          </button>
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 bg-zinc-950 text-white flex items-center justify-center">
              <ShippingContainerIcon size={16} weight="bold" />
            </div>
            <span className="font-heading font-black text-sm tracking-tight">CARGO/SCAN</span>
          </div>
          <span className="w-2 h-2 bg-emerald-500 live-dot" />
        </div>

        {/* Page header */}
        <header className="border-b border-zinc-200 bg-white px-4 sm:px-6 lg:px-8 py-5 lg:py-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between sm:gap-6 lg:sticky lg:top-0 lg:z-10">
          <div>
            <div className="overline">Control Room</div>
            <h1
              data-testid="page-title"
              className="font-heading text-2xl sm:text-3xl lg:text-4xl font-black tracking-tight text-zinc-950 mt-1"
            >
              {title}
            </h1>
            {subtitle && (
              <p className="text-sm text-zinc-500 mt-1 max-w-2xl">{subtitle}</p>
            )}
          </div>
          {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
        </header>

        <div className="p-4 sm:p-6 lg:p-8">{children}</div>
      </main>

      <MobileBottomNav />
      <PWAInstallBanner />
    </div>
  );
}
